module.exports = __webpack_public_path__ + "img/img_wuxinxi.63d0f57e.png";